@if (visible$ | async) { @if (product$ | async; as product) { @for (attr of product.variableVariationAttributes; track
attr) {
<div class="product-variation read-only">
  <span class="product-variation-info span-separator">{{ attr.name }}</span>
  <span>{{ attr | ishVariationAttribute }}</span>
</div>
} } }
